import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        VRow,
        {
          staticClass: "justify-center ma-2",
          attrs: { id: "grafico-redes", "no-gutters": "" },
        },
        [
          _c(
            VCol,
            [
              _c("network-chart", {
                staticClass: "network",
                attrs: {
                  dados: _vm.graficosGeral.responsabilidade.network.dados,
                  fonte: `Sistema Desenvolva, ${_vm.anoMapeamento}`,
                  nos: _vm.graficosGeral.responsabilidade.network.nos,
                  titulo: "Monitoramento Geral de Responsabilidades",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VRow,
        [
          _c(
            VToolbar,
            { attrs: { flat: "" } },
            [
              _c(VToolbarTitle, [
                _c(
                  "h2",
                  {
                    staticClass:
                      "title primary--text text--darken-1 text-no-wrap mt-0",
                  },
                  [_vm._v(" RESULTADOS ")]
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VRow,
        [
          _c(
            VCol,
            [
              _c("app-sort", {
                model: {
                  value: _vm.opcoes,
                  callback: function ($$v) {
                    _vm.opcoes = $$v
                  },
                  expression: "opcoes",
                },
              }),
            ],
            1
          ),
          _c(VSpacer),
          _c(
            VCol,
            [
              _c("app-search", {
                model: {
                  value: _vm.opcoes,
                  callback: function ($$v) {
                    _vm.opcoes = $$v
                  },
                  expression: "opcoes",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VRow,
        [
          _c(
            VCol,
            [
              _c(VDataTable, {
                staticClass: "elevation-0",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.relatorios,
                  search: _vm.opcoes.pesquisa,
                  "sort-by": _vm.opcoes.ordenarPor,
                  "sort-desc": _vm.opcoes.decrescente,
                  "align-content-space-between": "",
                  "disable-pagination": "",
                  "hide-default-footer": "",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: `body.append`,
                      fn: function () {
                        return [
                          _c("tr", [
                            _c(
                              "td",
                              { attrs: { align: "center", colspan: "2" } },
                              [
                                _c(
                                  "strong",
                                  {
                                    staticClass:
                                      "subtitle-2 grey--text text--darken-2",
                                  },
                                  [_vm._v("TOTAL")]
                                ),
                              ]
                            ),
                            _c("td", { attrs: { align: "center" } }, [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.totalResponsabilidades)),
                              ]),
                            ]),
                            _c("td", { attrs: { align: "center" } }, [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.totalResponsabilidadesNormalizadas)
                                ),
                              ]),
                            ]),
                            _c("td", { attrs: { align: "center" } }, [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.totalResponsabilidadesValidadas)
                                ),
                              ]),
                            ]),
                            _c("td", { attrs: { align: "center" } }, [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.totalResponsabilidadesConsolidadas)
                                ),
                              ]),
                            ]),
                            _c("td", { attrs: { align: "center" } }, [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.totalServidores)),
                              ]),
                            ]),
                          ]),
                          _c(VDivider),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VRow,
        [
          _c(
            VCol,
            { attrs: { lg: "6", md: "5", sm: "6" } },
            [
              _c(
                VRow,
                { staticClass: "justify-center" },
                [
                  _c("pie-chart", {
                    staticClass: "chart-2",
                    attrs: {
                      id: "grafico-pizza-dificuldades",
                      dados: _vm.graficosGeral.responsabilidade.pie2.series,
                      "dados-complementares":
                        _vm.graficosGeral.responsabilidade.pie2.subSeries,
                      fonte: `Fonte: Sistema Desenvolva, ${_vm.anoMapeamento}`,
                      titulo:
                        "Comparativo de Dificuldades das Responsabilidades<br> Consolidadas",
                    },
                  }),
                ],
                1
              ),
              _c(
                VRow,
                { staticClass: "justify-center" },
                [_c("legenda-dificuldade")],
                1
              ),
            ],
            1
          ),
          _c(
            VCol,
            { attrs: { lg: "6", md: "5", sm: "6" } },
            [
              _c(
                VRow,
                { staticClass: "justify-center" },
                [
                  _c("pie-chart", {
                    staticClass: "chart-2",
                    attrs: {
                      id: "grafico-pizza-impactos",
                      dados: _vm.graficosGeral.responsabilidade.pie.series,
                      "dados-complementares":
                        _vm.graficosGeral.responsabilidade.pie.subSeries,
                      fonte: `Fonte: Sistema Desenvolva, ${_vm.anoMapeamento}`,
                      titulo:
                        "Comparativo de Impactos das Responsabilidades<br> Consolidadas",
                    },
                  }),
                ],
                1
              ),
              _c(
                VRow,
                { staticClass: "justify-center" },
                [_c("legenda-impacto")],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VRow,
        { staticClass: "justify-center" },
        [
          _c(
            VCol,
            { attrs: { lg: "6", md: "5", sm: "6" } },
            [
              _c(
                VRow,
                { staticClass: "justify-center" },
                [
                  _c("pie-chart", {
                    staticClass: "chart-2",
                    attrs: {
                      id: "grafico-pizza-complexidades",
                      dados: _vm.graficosGeral.responsabilidade.pie3.series,
                      "dados-complementares":
                        _vm.graficosGeral.responsabilidade.pie3.subSeries,
                      fonte: `Fonte: Sistema Desenvolva, ${_vm.anoMapeamento}`,
                      titulo:
                        "Comparativo de Complexidades das Responsabilidades<br> Consolidadas",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VRow,
        { staticClass: "justify-center" },
        [_c("legenda-complexidade")],
        1
      ),
      _c(
        VRow,
        { staticClass: "mt-8" },
        [
          _c(
            VToolbar,
            { attrs: { flat: "" } },
            [
              _c(VToolbarTitle, [
                _c(
                  "h2",
                  {
                    staticClass:
                      "title primary--text text--darken-1 text-no-wrap mt-0",
                  },
                  [
                    _vm._v(
                      " RESPONSABILIDADES CONSOLIDADAS " +
                        _vm._s(`(${_vm.responsabilidades.length})`) +
                        " "
                    ),
                  ]
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VRow,
        [
          _c(
            VCol,
            [
              _c("app-sort", {
                model: {
                  value: _vm.opcoesResponsabilidades,
                  callback: function ($$v) {
                    _vm.opcoesResponsabilidades = $$v
                  },
                  expression: "opcoesResponsabilidades",
                },
              }),
            ],
            1
          ),
          _c(VSpacer),
          _c(
            VCol,
            [
              _c("app-search", {
                model: {
                  value: _vm.opcoesResponsabilidades,
                  callback: function ($$v) {
                    _vm.opcoesResponsabilidades = $$v
                  },
                  expression: "opcoesResponsabilidades",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VRow,
        [
          _c(
            VCol,
            [
              _c(VDataTable, {
                staticClass: "elevation-0",
                attrs: {
                  headers: _vm.headersResponsabilidades,
                  items: _vm.responsabilidades,
                  search: _vm.opcoesResponsabilidades.pesquisa,
                  "sort-by": _vm.opcoesResponsabilidades.ordenarPor,
                  "sort-desc": _vm.opcoesResponsabilidades.decrescente,
                  "show-expand": "",
                  "single-expand": "",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: `item.complexidade`,
                      fn: function ({ item }) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                item.complexidadeConsolidado.nome.toUpperCase()
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.data-table-expand`,
                      fn: function ({ item, expand, isExpanded }) {
                        return [
                          _c(
                            VTooltip,
                            {
                              attrs: { top: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on }) {
                                      return [
                                        _c(
                                          VBtn,
                                          _vm._g(
                                            {
                                              attrs: {
                                                height: "100%",
                                                text: "",
                                                width: "100%",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  expand(!isExpanded)
                                                  _vm.generateColumns(
                                                    _vm.colunas,
                                                    item.competenciasTecnicasConsolidado
                                                  )
                                                },
                                              },
                                            },
                                            on
                                          ),
                                          [
                                            _c(
                                              VBadge,
                                              {
                                                attrs: { right: "" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "badge",
                                                      fn: function () {
                                                        return [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                item
                                                                  .competenciasTecnicasConsolidado
                                                                  .length
                                                              )
                                                            ),
                                                          ]),
                                                        ]
                                                      },
                                                      proxy: true,
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              },
                                              [
                                                _c(
                                                  VIcon,
                                                  {
                                                    attrs: {
                                                      color: "grey lighten-0",
                                                      large: "",
                                                    },
                                                  },
                                                  [_vm._v(" build ")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  "Clique para exibir as competências técnicas"
                                ),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "expanded-item",
                      fn: function ({ headers }) {
                        return [
                          _c(
                            "td",
                            {
                              staticClass: "justify-center",
                              attrs: { colspan: headers.length },
                            },
                            [
                              _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(VSpacer),
                                  _c(
                                    VCol,
                                    [
                                      _c(
                                        VRow,
                                        { staticClass: "justify-center" },
                                        [
                                          _c(
                                            "h2",
                                            {
                                              staticClass:
                                                "title primary--text text--darken-1 text-no-wrap",
                                            },
                                            [_vm._v(" COMPETÊNCIAS TÉCNICAS ")]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(VSpacer),
                                ],
                                1
                              ),
                              _c(
                                VRow,
                                [
                                  _c(VSpacer),
                                  _c(
                                    VCol,
                                    { attrs: { cols: "10" } },
                                    [
                                      _c(VSimpleTable, {
                                        staticClass: "elevation-0 mb-4",
                                        attrs: { dense: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "tbody",
                                                    _vm._l(
                                                      _vm.colunas.lista,
                                                      function (column) {
                                                        return _c(
                                                          "tr",
                                                          { key: column.id },
                                                          _vm._l(
                                                            column,
                                                            function (
                                                              competencia
                                                            ) {
                                                              return _c(
                                                                "td",
                                                                {
                                                                  key: competencia.id,
                                                                  attrs: {
                                                                    width:
                                                                      "30%",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "d-flex flex-row ma-1",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          class:
                                                                            competencia.tipo ===
                                                                            "GERAL"
                                                                              ? "secondary--text"
                                                                              : "grey-text text--darken-2",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              competencia.nomeAtual
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(VSpacer),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VRow,
        { staticClass: "justify-end mb-1" },
        [
          _c(
            VTooltip,
            {
              attrs: { top: "", "max-width": "400" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function ({ on }) {
                    return [
                      _c(
                        VBtn,
                        _vm._g(
                          {
                            staticClass: "mr-2",
                            attrs: {
                              color: "success",
                              disabled: _vm.responsabilidades.length === 0,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.generateWorksheet()
                              },
                            },
                          },
                          on
                        ),
                        [
                          _c(VIcon, [_vm._v("get_app")]),
                          _vm._v(" BAIXAR XLS "),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            },
            [
              _c("span", [
                _vm._v("Clique para baixar os dados em formato XLS."),
              ]),
            ]
          ),
          _c(
            VTooltip,
            {
              attrs: { "max-width": "400", top: "" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function ({ on }) {
                    return [
                      _c(
                        VBtn,
                        _vm._g(
                          {
                            attrs: { color: "success" },
                            on: {
                              click: function ($event) {
                                return _vm.getRelatorio()
                              },
                            },
                          },
                          on
                        ),
                        [
                          _c(VIcon, [_vm._v("get_app")]),
                          _vm._v(" BAIXAR PDF "),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            },
            [
              _c("span", [
                _vm._v(
                  "Clique para baixar o relatório dos dados em formato PDF."
                ),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }